interface SvgMenuProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgMenu(props: SvgMenuProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M21 6H3V7.5H21V6Z" fill="currentColor" /><path d="M21 11H3V12.5H21V11Z" fill="currentColor" /><path d="M21 16H3V17.5H21V16Z" fill="currentColor" /></svg>;
}